/* Cheese Squishy - rails, ajout panier, filtres, densite, page suivante. Aucune dependance. */
(function () {
  'use strict';
  if (window.__csHome) return;
  window.__csHome = 1;

  /* ---- rails : fleches + etat des boutons ---- */
  function wireRail(wrap) {
    var rail = wrap.querySelector('[data-cs-rail]');
    if (!rail) return;
    var prev = wrap.querySelector('[data-cs-prev]');
    var next = wrap.querySelector('[data-cs-next-rail]') || wrap.querySelector('[data-cs-next]');
    if (!prev || !next) return;
    function step() {
      var first = rail.firstElementChild;
      if (!first) return rail.clientWidth;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function sync() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      var on = max > 2;
      prev.hidden = !on || rail.scrollLeft <= 2;
      next.hidden = !on || rail.scrollLeft >= max;
    }
    prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    rail.addEventListener('scroll', sync, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(sync).observe(rail);
    sync();
  }

  /* ---- panier : rafraichit la pastille du header si le theme l'expose ---- */
  function refreshBubble() {
    var host = document.getElementById('shopify-section-cart-icon-bubble');
    if (!host) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + '?sections=cart-icon-bubble')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { if (d && d['cart-icon-bubble']) host.innerHTML = d['cart-icon-bubble']; })
      .catch(function () {});
  }

  function wireForm(form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch || form.__bypass) return;    /* repli : soumission normale vers /cart */
      e.preventDefault();
      var btn = form.querySelector('[data-cs-add]');
      if (!btn || btn.disabled) return;
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = btn.getAttribute('data-loading') || 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(form.querySelector('[name=id]').value), quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function () {
          btn.textContent = btn.getAttribute('data-done') || 'Added';
          refreshBubble();
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1600);
        })
        .catch(function () { form.__bypass = 1; btn.disabled = false; form.submit(); });
    });
  }

  /* ---- page collection : tiroir de filtres + tri ---- */
  function wireFilters(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-cs-filter-open]').forEach(function (b) {
      if (b.__cs) return; b.__cs = 1;
      var panel = document.getElementById(b.getAttribute('aria-controls'));
      if (!panel) return;
      function close() {
        panel.hidden = true;
        b.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        b.focus();
      }
      b.addEventListener('click', function () {
        panel.hidden = false;
        b.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        var f = panel.querySelector('summary, input, button');
        if (f) f.focus();
      });
      panel.querySelectorAll('[data-cs-filter-close]').forEach(function (x) { x.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) close(); });
    });
    scope.querySelectorAll('[data-cs-sortform] select').forEach(function (sel) {
      if (sel.__cs) return; sel.__cs = 1;
      sel.addEventListener('change', function () { sel.form.submit(); });
    });
  }

  /* ---- densite de la grille, memorisee par visiteur ---- */
  function gridHost() {
    var list = document.querySelector('[data-cs-list]');
    return list ? list.closest('.cs') : null;
  }
  function markDensity(v) {
    var host = gridHost();
    var cur = v || (host && getComputedStyle(host).getPropertyValue('--cs-col').trim());
    document.querySelectorAll('[data-cs-dens]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-cs-dens') === String(cur) ? 'true' : 'false');
    });
  }
  function setDensity(v, quiet) {
    var host = gridHost();
    if (host) host.style.setProperty('--cs-col', v);
    if (!quiet) { try { localStorage.setItem('csDensity', v); } catch (e) {} }
    markDensity(v);
  }
  function wireDensity(root) {
    (root || document).querySelectorAll('[data-cs-dens]').forEach(function (b) {
      if (b.__cs) return; b.__cs = 1;
      b.addEventListener('click', function () { setDensity(b.getAttribute('data-cs-dens')); });
    });
    var saved = null;
    try { saved = localStorage.getItem('csDensity'); } catch (e) {}
    if (saved) setDensity(saved, true); else markDensity();
  }

  /* ---- produits suivants : le <a href> reste un VRAI lien explorable ---- */
  function wireMore(root) {
    var nav = (root || document).querySelector('[data-cs-more]');
    if (!nav || nav.__cs) return;
    nav.__cs = 1;
    var mode = nav.getAttribute('data-cs-more');
    if (mode === 'pages') return;
    var list = document.querySelector('[data-cs-list]');
    var link = nav.querySelector('[data-cs-next]');
    var prog = nav.querySelector('[data-cs-progress]');
    var sid = nav.getAttribute('data-cs-section');
    var busy = false;
    if (!list || !link) return;

    function load() {
      if (busy || !link) return;
      busy = true;
      var href = link.getAttribute('href');
      var url = href + (href.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sid;
      var old = link.textContent;
      link.setAttribute('aria-busy', 'true');
      link.textContent = 'Loading...';
      fetch(url)
        .then(function (r) { if (!r.ok) throw 0; return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.querySelector('[data-cs-list]');
          if (next) { while (next.firstElementChild) list.appendChild(next.firstElementChild); }
          var nn = doc.querySelector('[data-cs-next]');
          var np = doc.querySelector('[data-cs-progress]');
          if (prog && np) prog.textContent = np.textContent;
          if (nn) {
            link.setAttribute('href', nn.getAttribute('href'));
            link.textContent = old;
            link.removeAttribute('aria-busy');
          } else {
            link.parentNode.removeChild(link);
            link = null;
          }
          busy = false;
          init(list);
        })
        .catch(function () {
          busy = false;
          window.location.href = link.getAttribute('href');   /* repli : navigation reelle */
        });
    }

    link.addEventListener('click', function (e) { e.preventDefault(); load(); });

    if (mode === 'infinite' && window.IntersectionObserver) {
      var io = new IntersectionObserver(function (en) {
        if (!link) { io.disconnect(); return; }
        if (en[0].isIntersecting) load();
      }, { rootMargin: '600px' });
      io.observe(nav);
    }
  }


  /* ---- fiche produit : galerie, vignettes, compteur ---- */
  function wireGallery(root) {
    (root || document).querySelectorAll('[data-cs-stage]').forEach(function (stage) {
      if (stage.__cs) return; stage.__cs = 1;
      var track = stage.querySelector('[data-cs-track]');
      if (!track) return;
      var slides = track.children;
      var prev = stage.querySelector('[data-cs-prev]');
      var next = stage.querySelector('[data-cs-next-img]');
      var count = stage.querySelector('[data-cs-count]');
      var media = stage.closest('.cs-pd__media');
      var thumbs = media ? media.querySelectorAll('[data-cs-thumb]') : [];

      function index() {
        return Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      }
      function go(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      }
      function sync() {
        var i = index();
        if (count) count.textContent = (i + 1) + ' / ' + slides.length;
        if (prev) prev.hidden = i <= 0;
        if (next) next.hidden = i >= slides.length - 1;
        for (var k = 0; k < thumbs.length; k++) {
          thumbs[k].setAttribute('aria-current', k === i ? 'true' : 'false');
        }
      }
      if (prev) prev.addEventListener('click', function () { go(index() - 1); });
      if (next) next.addEventListener('click', function () { go(index() + 1); });
      for (var k = 0; k < thumbs.length; k++) {
        (function (b) {
          b.addEventListener('click', function () { go(Number(b.getAttribute('data-cs-thumb'))); });
        })(thumbs[k]);
      }
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      stage.__go = go;
      sync();
    });
  }

  /* ---- fiche produit : quantite, declinaisons, prix, barre collante ---- */
  function wirePdp(root) {
    var pdp = (root || document).querySelector('[data-cs-pdp]');
    if (!pdp || pdp.__cs) return;
    pdp.__cs = 1;

    var form = pdp.querySelector('[data-cs-pform]');
    var qtyBox = pdp.querySelector('.cs-pd__qty');
    if (qtyBox) {
      var input = qtyBox.querySelector('input');
      qtyBox.querySelector('[data-cs-qm]').addEventListener('click', function () {
        input.value = Math.max(1, (Number(input.value) || 1) - 1);
      });
      qtyBox.querySelector('[data-cs-qp]').addEventListener('click', function () {
        input.value = (Number(input.value) || 1) + 1;
      });
    }

    var data = document.querySelector('[data-cs-variants]');
    var variants = [];
    try { variants = JSON.parse(data.textContent); } catch (e) {}

    var pills = pdp.querySelectorAll('[data-cs-opt]');
    var idField = pdp.querySelector('[data-cs-vid]');
    var priceEl = pdp.querySelector('[data-cs-p]');
    var wasEl = pdp.querySelector('[data-cs-was]');
    var offEl = pdp.querySelector('[data-cs-off]');
    var atc = pdp.querySelector('[data-cs-add]');
    var atcLabel = pdp.querySelector('[data-cs-atclabel]');
    var stage = pdp.querySelector('[data-cs-stage]');
    var stickyPrice = document.querySelector('[data-cs-stickyprice]');

    function chosen() {
      var out = [];
      pdp.querySelectorAll('[data-cs-optgroup]').forEach(function (g, i) {
        var on = g.querySelector('[aria-pressed="true"]');
        out[i] = on ? on.getAttribute('data-cs-val') : null;
      });
      return out;
    }
    function match(sel) {
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < sel.length; j++) {
          if (sel[j] !== null && variants[i].opts[j] !== sel[j]) { ok = false; break; }
        }
        if (ok) return variants[i];
      }
      return null;
    }
    function apply(vr) {
      if (!vr) return;
      if (idField) idField.value = vr.id;
      if (priceEl) priceEl.textContent = vr.priceStr;
      if (stickyPrice) stickyPrice.textContent = vr.priceStr;
      var onSale = vr.cmp && vr.cmp > vr.price;
      if (wasEl) { wasEl.textContent = vr.cmpStr; wasEl.hidden = !onSale; }
      if (offEl) {
        offEl.hidden = !onSale;
        if (onSale) offEl.textContent = '-' + Math.round((vr.cmp - vr.price) * 100 / vr.cmp) + '%';
      }
      if (atc) {
        atc.disabled = !vr.available;
        if (atcLabel) atcLabel.textContent = vr.available ? (atc.getAttribute('data-label') || atcLabel.textContent) : 'Sold out';
      }
      if (vr.img && stage && stage.__go) stage.__go(vr.img - 1);
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', vr.id);
        window.history.replaceState({}, '', u.toString());
      } catch (e) {}
    }

    pills.forEach(function (b) {
      b.addEventListener('click', function () {
        var gi = b.getAttribute('data-cs-opt');
        pdp.querySelectorAll('[data-cs-opt="' + gi + '"]').forEach(function (o) {
          o.setAttribute('aria-pressed', o === b ? 'true' : 'false');
        });
        var lab = pdp.querySelector('[data-cs-optval="' + gi + '"]');
        if (lab) lab.textContent = b.getAttribute('data-cs-val');
        apply(match(chosen()));
      });
    });
    if (atc && atcLabel) atc.setAttribute('data-label', atcLabel.textContent);

    /* barre collante : visible quand le bouton principal sort de l ecran */
    var bar = document.querySelector('[data-cs-stickybar]');
    if (bar && atc && window.IntersectionObserver) {
      var io = new IntersectionObserver(function (en) {
        var out = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        bar.classList.toggle('is-on', out);
        bar.setAttribute('aria-hidden', out ? 'false' : 'true');
      }, { threshold: 0 });
      io.observe(atc);
      var sb = bar.querySelector('[data-cs-stickyadd]');
      if (sb && form) sb.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
    }
  }


  /* ---- recommandations : n ecrase le rail QUE si Shopify renvoie des produits ---- */
  function wireReco(root) {
    (root || document).querySelectorAll('[data-cs-reco]').forEach(function (host) {
      if (host.__cs) return; host.__cs = 1;
      var url = host.getAttribute('data-cs-reco');
      host.removeAttribute('data-cs-reco');
      fetch(url)
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cs-rail]');
          var rail = host.querySelector('[data-cs-rail]');
          if (!fresh || !rail || fresh.children.length === 0) return;  /* rien de mieux : on garde le repli */
          rail.innerHTML = fresh.innerHTML;
          init(host);
        })
        .catch(function () {});
    });
  }

  // Cartes "savoir-faire" : le bandeau se deplie au clic (visuel ou bouton +).
  // Le survol est gere en CSS sur les appareils a curseur ; ici on ne pose que
  // l etat clique, pour que le clavier et le tactile fonctionnent aussi.
  function wireReveal(card) {
    if (card.__csrev) return;
    card.__csrev = 1;
    var btn = card.querySelector('[data-cs-reveal-btn]');
    if (!btn) return;
    var hit = card.querySelector('[data-cs-reveal-hit]');
    var wrap = card.querySelector('.cs-ac__xw');

    /* On mesure la hauteur reelle du texte et on la passe au CSS (--ac-h) :
       le bandeau s ouvre alors par une translation, composee par le GPU, au
       lieu de refaire la mise en page a chaque image. scrollHeight se lit meme
       quand l element est plie, donc rien a deplier pour mesurer. */
    function measure() {
      if (!wrap) return;
      var h = wrap.scrollHeight;
      if (!h) return;
      card.style.setProperty('--ac-h', Math.ceil(h) + 'px');
      card.classList.add('cs-ac--anim');
    }

    function set(on) {
      card.classList.toggle('is-open', on);
      btn.setAttribute('aria-expanded', on ? 'true' : 'false');
    }
    function toggle(e) {
      if (e) e.preventDefault();
      set(!card.classList.contains('is-open'));
    }

    btn.addEventListener('click', toggle);
    if (hit) hit.addEventListener('click', toggle);
    card.addEventListener('mouseleave', function () { set(false); });

    measure();
    /* la hauteur du texte change avec la largeur de la carte et une fois les
       polices chargees : on remesure sans jamais toucher a la taille de la carte,
       donc l observateur ne peut pas boucler. */
    if (window.ResizeObserver) {
      new ResizeObserver(measure).observe(card);
    } else {
      window.addEventListener('resize', measure);
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
  }

  /* ============================================================
     PANIER — ajout au tiroir
     Le theme expose l API Dawn sur <cart-drawer> : open(), close(),
     renderContents(), getSectionsToRender(). On s y branche au lieu
     de laisser le formulaire produit poster vers /cart.
     Le CONTENU du tiroir est rendu par le serveur
     (snippets/cart-drawer.liquid) et pilote par cs-cart.js : plus
     aucun montant ni libelle n est peint ici.
     ============================================================ */

  function csDrawer() { return document.querySelector('cart-drawer'); }

  function csAdd(form, btn) {
    var drawer = csDrawer();
    var idField = form.querySelector('[name=id]');
    if (!idField) return false;
    var qtyField = form.querySelector('[name=quantity]');
    var qty = Math.max(1, Number(qtyField && qtyField.value) || 1);

    var body = { items: [{ id: Number(idField.value), quantity: qty }] };
    if (drawer && drawer.getSectionsToRender) {
      try {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      } catch (e) {}
    }

    var label = btn ? btn.textContent : '';
    if (btn) {
      btn.disabled = true;
      btn.textContent = btn.getAttribute('data-loading') || 'Adding...';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (data) {
        if (btn) {
          btn.textContent = btn.getAttribute('data-done') || 'Added';
          setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1600);
        }
        if (drawer) drawer.classList.remove('cs-cd--empty');
        if (drawer && data && data.sections && drawer.renderContents) {
          drawer.renderContents(data);
          /* filet de securite : renderContents ouvre le tiroir apres deux
             images d animation. Si celles-ci sont gelees (onglet en arriere
             plan, moteur d animation indisponible), on ouvre nous-memes. */
          setTimeout(function () {
            if (drawer.open && !drawer.classList.contains('open')) drawer.open();
          }, 450);
        } else {
          refreshBubble();
          if (drawer && drawer.open) drawer.open();
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () {
        form.__bypass = 1;
        if (btn) { btn.disabled = false; btn.textContent = label; }
        form.submit();
      });
    return true;
  }

  function wireAddForm(form) {
    if (form.__csadd) return;
    form.__csadd = 1;
    form.addEventListener('submit', function (e) {
      if (!window.fetch || form.__bypass) return;
      var btn = form.querySelector('[data-cs-add]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      csAdd(form, btn);
    });
  }

  function wireCart(root) {
    (root || document).querySelectorAll('form[data-cs-pform], form[data-cs-form]').forEach(wireAddForm);
  }


  function init(root) {
    (root || document).querySelectorAll('[data-cs-wrap]').forEach(wireRail);
    (root || document).querySelectorAll('[data-cs-reveal]').forEach(wireReveal);
    wireCart(root);

    wireFilters(root);
    wireDensity(root);
    wireMore(root);
    wireGallery(root);
    wirePdp(root);
    wireReco(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
